import React from 'react';
import styles from './styles.module.scss';
import CommentPanelHeader from './CommentPanelHeader/CommentPanelHeader';
import RoadmapComments, { CommentListOnly } from './RoadmapComments';
import FilterDropdown from './FilterDropdown/FilterDropdown';
import SendViaSection from './SendViaSection/SendViaSection';
import { useCommentSlice } from './CommentState';

interface CommentPanelProps {
  isOpen: boolean;
  onClose: () => void;
}

export const CommentPanel: React.FC<CommentPanelProps> = ({
  isOpen,
  onClose
}) => {
  // Initialize Redux slice
  useCommentSlice();

  return (
    <div
      className={`${styles.commentPanel} ${isOpen ? styles.open : ''}`}
      role="complementary"
      aria-label="Comments panel"
      data-testid="comment-panel"
    >
      <CommentPanelHeader onClose={onClose} />
      <SendViaSection />
      <div className={styles.stickyContent}>
        <FilterDropdown />
        <RoadmapComments />
      </div>
      <div className={styles.scrollableContent}>
        <CommentListOnly />
      </div>
    </div>
  );
};

export default CommentPanel;
